import React from 'react';
import { motion } from 'framer-motion';
import SEO from './SEO';
import './Loading.css';

const Loading = () => {
  return (
    <>
      <SEO 
        title="Loading - Student Helper"
        description="Please wait while we load your content."
        keywords="student helper loading, loading screen, loading indicator"
      />
      <div className="loading-container">
        <motion.div 
          className="loading-spinner"
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
        >
          Loading...
        </motion.p>
      </div>
    </>
  );
};

export default Loading; 